import { gql } from "graphql-request";
import type { ShopifyMoney } from "./common.ts";

type GetVariantByIdQuery = {
	readonly node: {
		readonly id: string;
		readonly __typename: string;
		readonly price: ShopifyMoney;
		readonly selectedOptions: readonly {
			readonly name: string;
			readonly value: string;
		}[];
		readonly product: {
			readonly title: string;
			readonly handle: string;
		};
	} | null;
};

type GetVariantByIdVariables = {
	readonly id: string;
	readonly countryCode: string;
};

const getVariantByIdQuery = gql`
	query getVariantById($id: ID!, $countryCode: CountryCode!)
	@inContext(country: $countryCode) {
		node(id: $id) {
			id
			__typename
			... on ProductVariant {
				price {
					amount
					currencyCode
				}
				selectedOptions {
					name
					value
				}
				product {
					title
					handle
				}
			}
		}
	}
`;

export type { GetVariantByIdQuery, GetVariantByIdVariables };
export default getVariantByIdQuery;
